/**
 * AONA Luxury AI-Powered Search Bar & Suggested Products Dropdown
 * Inspired by Pepperfry with NVIDIA AI Dynamic Search Term Generation
 */

(function() {
  if (window.aonaAiSearchInitialized) return;
  window.aonaAiSearchInitialized = true;
  var STORAGE_TERMS_KEY = "aona_ai_search_terms_cache";
  var STORAGE_RECENT_KEY = "aona_recent_searches";

  var defaultTerms = [
    '"Brass Ganesha Idols"',
    '"Radha Krishna Murti"',
    '"Urli Bowls with Candles"',
    '"Handcrafted Pooja Diyas"',
    '"Lord Shiva Shankar Statue"',
    '"Buddha for Living Room"',
    '"Ashoka Stambh Emblem"',
    '"Karungali Mala & Bracelet"',
    '"Brass Peacock Lamp"',
    '"Ram Darbar Idol"',
    '"Brass Elephant Pair"',
    '"Tirupati Balaji Statue"',
    '"Vintage Bronze Sculptures"',
    '"Home Mandir Decor"'
  ];

  var searchTerms = defaultTerms.slice();
  var currentTermIdx = 0;
  var rotateInterval = null;
  var debounceTimer = null;
  var searchRequestSequence = 0;
  var searchController = null;
  var cachedSuggestedProducts = null;

  // Load cached AI terms from localStorage
  try {
    var cached = JSON.parse(localStorage.getItem(STORAGE_TERMS_KEY) || 'null');
    if (cached && cached.terms && cached.terms.length > 0 && (Date.now() - cached.timestamp < 86400000)) {
      searchTerms = cached.terms;
    }
  } catch(e) {}

  // Fetch fresh AI suggestions in background via NVIDIA API
  function fetchAiSearchSuggestions() { /* Local suggestions remain available; no provider secret is sent by the browser. */ }

  function initPlaceholderRotation() {
    var input = document.querySelector('.aona-search-input-field, .aona-search-input');
    var box = document.querySelector('.aona-placeholder-sliding-box');
    var placeholderWrapper = document.querySelector('.aona-animated-placeholder');
    if (!input || !box || !placeholderWrapper) return;
    // A header reload or repeated script must not start a second rotation.
    if (box.dataset.aonaRotationInitialized === 'true') return;
    box.dataset.aonaRotationInitialized = 'true';
    var rotating = false;

    if (rotateInterval) clearInterval(rotateInterval);

    function rotateNext() {
      if (rotating || document.activeElement === input || input.value.trim() !== '') return;
      rotating = true;

      var currentEl = box.querySelector('.aona-placeholder-sliding-term.active');
      // Retain only the current term if an earlier animation was interrupted.
      box.querySelectorAll('.aona-placeholder-sliding-term').forEach(function(term) {
        if (term !== currentEl) term.remove();
      });
      currentTermIdx = (currentTermIdx + 1) % searchTerms.length;

      var nextEl = document.createElement('span');
      nextEl.className = 'aona-placeholder-sliding-term slide-in-start';
      nextEl.textContent = searchTerms[currentTermIdx];

      if (currentEl) {
        currentEl.classList.remove('active');
        currentEl.classList.add('slide-out');
      }

      box.appendChild(nextEl);

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          nextEl.classList.remove('slide-in-start');
          nextEl.classList.add('active');
          // Start cleanup after the frame runs; background tabs may defer it.
          setTimeout(function() {
            if (currentEl && currentEl.parentNode) {
              currentEl.parentNode.removeChild(currentEl);
            }
            rotating = false;
          }, 400);
        });
      });
    }

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) rotateInterval = setInterval(rotateNext, 2600);

    function syncPlaceholder() {
      if (document.activeElement === input || input.value.trim() !== '') {
        placeholderWrapper.classList.add('is-hidden');
      } else {
        placeholderWrapper.classList.remove('is-hidden');
      }
    }

    input.addEventListener('input', syncPlaceholder);
    input.addEventListener('focus', syncPlaceholder);
    input.addEventListener('blur', syncPlaceholder);
    syncPlaceholder();
  }

  function renderTrendingChips(customTags) {
    var container = document.querySelector('.aona-search-tags-grid');
    if (!container) return;

    var tags = customTags || [
      'Brass Ganesha',
      'Urli Bowls',
      'Radha Krishna',
      'Pooja Diya',
      'Lord Shiva',
      'Buddha Idols',
      'Karungali',
      'Ashoka Emblem',
      'Brass Nataraja',
      'Peacock Lamp'
    ];

    var html = '';
    tags.slice(0, 10).forEach(function(tag) {
      var clean = tag.replace(/^["']|["']$/g, '');
      html += '<a href="/search?q=' + encodeURIComponent(clean) + '" class="aona-search-tag-chip" data-search-term="' + clean + '">' +
                '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
                clean +
              '</a>';
    });
    container.innerHTML = html;

    container.querySelectorAll('.aona-search-tag-chip').forEach(function(chip) {
      chip.addEventListener('click', function(e) {
        var term = this.dataset.searchTerm;
        saveRecentSearch(term);
      });
    });
  }

  function fetchSuggestedProducts() {
    var grid = document.querySelector('.aona-search-products-grid');
    if (!grid) return;

    if (cachedSuggestedProducts) {
      renderSuggestedProductsGrid(cachedSuggestedProducts);
      return;
    }

    fetch('/search/suggest.json?q=brass&resources[type]=product')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (prods.length > 0) {
          cachedSuggestedProducts = prods.slice(0, 6);
          renderSuggestedProductsGrid(cachedSuggestedProducts);
        } else {
          return fetch('/products.json?limit=6')
            .then(function(r) { return r.json(); })
            .then(function(d) {
              if (d && d.products) {
                cachedSuggestedProducts = d.products;
                renderSuggestedProductsGrid(cachedSuggestedProducts);
              }
            });
        }
      })
      .catch(function(err) {
        console.warn('Suggested products error:', err);
      });
  }

  function renderSuggestedProductsGrid(products) {
    var grid = document.querySelector('.aona-search-products-grid');
    if (!grid || !products || products.length === 0) return;

    var html = '';
    products.slice(0, 6).forEach(function(p) {
      var priceNum = Number(p.price || (p.variants && p.variants[0] ? p.variants[0].price : 0));
      var compareNum = Number(p.compare_at_price_min || p.compare_at_price || (p.variants && p.variants[0] ? p.variants[0].compare_at_price : 0));
      var priceStr = '₹' + Math.round(priceNum).toLocaleString('en-IN');
      var mrpStr = compareNum > priceNum ? '₹' + Math.round(compareNum).toLocaleString('en-IN') : '';
      var discount = compareNum > priceNum ? Math.round(((compareNum - priceNum) / compareNum) * 100) + '% OFF' : '';
      var img = p.image || p.featured_image || (p.images && p.images[0] ? p.images[0].src : '');
      var url = p.url ? p.url.split('?')[0] : ('/products/' + p.handle);

      html += `
        <a href="${url}" class="aona-search-product-item">
          <img src="${img}" alt="${p.title}" class="aona-search-product-thumb" loading="lazy" />
          <div class="aona-search-product-meta">
            <span class="aona-search-product-title">${p.title}</span>
            <div class="aona-search-product-price-row">
              <span class="aona-search-product-price">${priceStr}</span>
              ${mrpStr ? `<span class="aona-search-product-mrp">${mrpStr}</span>` : ''}
              ${discount ? `<span class="aona-search-product-badge">${discount}</span>` : ''}
            </div>
          </div>
        </a>
      `;
    });
    grid.innerHTML = html;
  }

  function loadRecentSearches() {
    var container = document.querySelector('.aona-recent-searches-section');
    var listEl = document.querySelector('.aona-recent-searches-list');
    if (!container || !listEl) return;

    var list = [];
    try {
      list = JSON.parse(localStorage.getItem(STORAGE_RECENT_KEY) || '[]');
    } catch(e) {}

    if (list.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = 'block';
    var html = '';
    list.slice(0, 6).forEach(function(term) {
      html += '<a href="/search?q=' + encodeURIComponent(term) + '" class="aona-search-tag-chip">' +
                '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>' +
                term +
              '</a>';
    });
    listEl.innerHTML = html;
  }

  function saveRecentSearch(term) {
    if (!term || term.trim() === '') return;
    term = term.trim();
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_RECENT_KEY) || '[]');
      list = list.filter(function(t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      if (list.length > 8) list = list.slice(0, 8);
      localStorage.setItem(STORAGE_RECENT_KEY, JSON.stringify(list));
    } catch(e) {}
  }

  function initPredictiveLiveSearch() {
    var input = document.querySelector('.aona-search-input-field, .aona-search-input');
    var defaultContent = document.querySelector('.aona-search-default-content');
    var predictiveContent = document.querySelector('.aona-predictive-results');
    var predictiveList = document.querySelector('.aona-predictive-list');
    var viewAllBtn = document.querySelector('.aona-predictive-view-all');
    if (!input || !defaultContent || !predictiveContent || !predictiveList) return;

    input.addEventListener('input', function() {
      var val = this.value.trim();
      var sequence = ++searchRequestSequence;
      if (searchController) searchController.abort();
      if (debounceTimer) clearTimeout(debounceTimer);

      if (val.length < 2) {
        defaultContent.style.display = 'block';
        predictiveContent.classList.remove('active');
        return;
      }

      debounceTimer = setTimeout(function() {
        searchController = new AbortController();
        fetch('/search/suggest.json?q=' + encodeURIComponent(val) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last', { signal: searchController.signal })
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(data) {
            if (sequence !== searchRequestSequence) return;
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length > 0) {
              // Keep Shopify relevance for specific searches; broad deity queries show
              // available, attainable choices first without hiding the full catalogue.
              if (/^(?:ganesh(?:a)?|ganpati|ganapati|lakshmi|laxmi|saraswati|saraswathi|dhanvantri|dhanvantari|dhanwantri|diya|deepak)$/i.test(val)) {
                products = products.map(function(p,i){return {p:p,i:i}}).sort(function(a,b){
                  var stockA=a.p.available===false?1:0,stockB=b.p.available===false?1:0;
                  var bandA=Number(a.p.price)>10000?1:0,bandB=Number(b.p.price)>10000?1:0;
                  return stockA-stockB||bandA-bandB||a.i-b.i;
                }).map(function(item){return item.p});
              }
              defaultContent.style.display = 'none';
              predictiveContent.classList.add('active');

              var html = '';
              products.slice(0, 6).forEach(function(p) {
                var priceStr = '₹' + Math.round(Number(p.price || 0)).toLocaleString('en-IN');
                var img = p.image || p.featured_image || '';
                var url = p.url ? p.url.split('?')[0] : ('/products/' + p.handle);

                html += `
                  <a href="${url}" class="aona-predictive-item">
                    <img src="${img}" alt="${p.title}" class="aona-predictive-item-img" />
                    <span class="aona-predictive-item-title">${p.title}</span>
                    <span class="aona-search-product-price">${priceStr}</span>
                  </a>
                `;
              });
              predictiveList.innerHTML = html;
              if (viewAllBtn) {
                viewAllBtn.href = '/search?q=' + encodeURIComponent(val);
                viewAllBtn.textContent = 'VIEW ALL RESULTS FOR "' + val.toUpperCase() + '" ➔';
              }
            } else {
              defaultContent.style.display = 'block';
              predictiveContent.classList.remove('active');
            }
          })
          .catch(function(error) {
            if (sequence !== searchRequestSequence || error.name === 'AbortError') return;
            defaultContent.style.display = 'block';
            predictiveContent.classList.remove('active');
          });
      }, 240);
    });
  }

  function initDropdownEvents() {
    var wrapper = document.querySelector('.aona-search-bar-wrapper, .aona-search-bar');
    var input = document.querySelector('.aona-search-input-field, .aona-search-input');
    var modal = document.querySelector('.aona-search-dropdown-modal');
    var form = document.querySelector('.aona-search-form-container form');
    var clearRecentBtn = document.querySelector('.aona-search-clear-recent');

    if (!input || !modal) return;

    function openDropdown() {
      modal.classList.add('active');
      loadRecentSearches();
      fetchSuggestedProducts();
    }

    function closeDropdown() {
      modal.classList.remove('active');
    }

    input.addEventListener('focus', openDropdown);
    input.addEventListener('click', openDropdown);

    document.addEventListener('click', function(e) {
      if (wrapper && !wrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeDropdown();
        input.blur();
      }
    });

    if (form) {
      form.addEventListener('submit', function() {
        saveRecentSearch(input.value);
      });
    }

    if (clearRecentBtn) {
      clearRecentBtn.addEventListener('click', function(e) {
        e.preventDefault();
        try {
          localStorage.removeItem(STORAGE_RECENT_KEY);
        } catch(e) {}
        loadRecentSearches();
      });
    }
  }

  function init() {
    initPlaceholderRotation();
    renderTrendingChips();
    initDropdownEvents();
    initPredictiveLiveSearch();
    // Background AI enhancement
    fetchAiSearchSuggestions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
